module.exports = (__webpack_require__(6370))("./node_modules/react-dom/index.js");